import { useRef } from 'react';
import { useMediaMatch } from '../../../hooks/useMediaMatch';
import { useTrapFocus } from '../../../hooks/useTrapFocus';
import { media } from '../../../stylings';
import type { NavigationHierarchyDataSubLevel } from '../../../types/navigationHierarchyData';
import { FeaturedCardContainer, MegaMenuWrapper, RowWrapper } from './MegaMenu.styles';
import { MegaMenuRow } from './megaMenuRow/megaMenuRow';

const MAX_ITEMS_FOR_LEFT_ALIGN = 2;

export type MegaMenuProps = {
  megaMenuData: NavigationHierarchyDataSubLevel;
  isActive: boolean;
  handleCloseMenu: () => void;
};

export function MegaMenu({ megaMenuData, isActive, handleCloseMenu }: MegaMenuProps) {
  const { layoutContent } = megaMenuData || {};
  const featuredCardArray = layoutContent?.filter((columnData) => 'featuredCards' in columnData);
  const navigationListArray = layoutContent?.filter((columnData) => 'navigationList' in columnData);
  const separateContent = useMediaMatch(media.between('lg', 'xl'));

  const megaMenuRef = useRef<HTMLDivElement>(null);

  useTrapFocus(isActive, megaMenuRef);

  return (
    <MegaMenuWrapper role="menu" ref={megaMenuRef}>
      {!separateContent && layoutContent ? (
        <RowWrapper $alignLeft={layoutContent.length <= MAX_ITEMS_FOR_LEFT_ALIGN}>
          <MegaMenuRow layoutContent={layoutContent} handleCloseMenu={handleCloseMenu} />
        </RowWrapper>
      ) : (
        <>
          {navigationListArray && (
            <RowWrapper $alignLeft={navigationListArray.length <= MAX_ITEMS_FOR_LEFT_ALIGN}>
              <MegaMenuRow layoutContent={navigationListArray} handleCloseMenu={handleCloseMenu} />
            </RowWrapper>
          )}
          {featuredCardArray && (
            <RowWrapper>
              <FeaturedCardContainer>
                <MegaMenuRow layoutContent={featuredCardArray} extendWidth handleCloseMenu={handleCloseMenu} />
              </FeaturedCardContainer>
            </RowWrapper>
          )}
        </>
      )}
    </MegaMenuWrapper>
  );
}

export default MegaMenu;
